import { useEffect, useRef } from 'react'
import useNormalizedProfile from '../../../redux/hooks/useNormalizedProfile'
import { initDocumentTitle } from '../../../modules/notifications/messageTitleFlash'
import { syncBrowserPushWithPreference } from '../../../modules/push/browserPush'

/**
 * Bootstraps notification UX helpers once the operator profile is available:
 * - captures the default document title for title-flash reset
 * - keeps Web Push subscription in sync with profile.browserNotification
 */
const BrowserPushRegistration = () => {
  const profile = useNormalizedProfile()
  const lastSynced = useRef(null)

  useEffect(() => {
    initDocumentTitle()
  }, [])

  useEffect(() => {
    if (!profile?.id) return
    const enabled = !!profile.browserNotification
    if (lastSynced.current === enabled) return
    lastSynced.current = enabled
    syncBrowserPushWithPreference(enabled).catch(err => {
      console.warn('[BrowserPushRegistration]', err?.message || err)
    })
  }, [profile?.id, profile?.browserNotification])

  return null
}

export default BrowserPushRegistration
